import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Feedback } from '../apimodels/feedback/feedback';
import { Observable } from 'rxjs';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(
    private httpClient: HttpClient,
    @Inject(ENVIRONMENT) private env: Environment
  ) {}

  submitFeedback(feedback: Feedback ): Observable<boolean> {
    return this.httpClient.post<boolean>(
      `${this.env.apiUrl}/Feedback/Submit`,
      feedback,
      { withCredentials: true }
    );
  }
}
